import { Component, Inject, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { DashboardService } from './../../../pages/dashboard/dashboard.service';
import { DashboardService } from '../../pages/dashboard/dashboard.service';
import { RestService } from '@services/rest.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { AppConfiguration } from '@config/app-configuration';

@Component({
  selector: 'app-smione-intro-screens',
  templateUrl: './carousels.component.html',
  styleUrls: ['./carousels.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SmioneIntroScreensComponent implements OnInit, OnDestroy {
  showAlternateIntroPop: boolean;
  isSkipUpgradeKudzu : boolean;
  smioneLoginRestrictmodalTrue : boolean;
  currentSlideIndex = 0;
  interval: any;
  slides: { title: string; description: string; image: string }[];
  closeIcon: string = '';
  isFromDashboard: boolean = false;
  cardKey: number;

  constructor(
    private dashboardServices: DashboardService,
    public dialogRef: MatDialogRef<SmioneIntroScreensComponent>,
    private oauthService: OAuthService,
    private restService: RestService,
    private appConfig: AppConfiguration,
    
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.showAlternateIntroPop = data.showAlternateIntroPop; 
    this.isSkipUpgradeKudzu = data.isSkipUpgradeKudzu; 
    this.smioneLoginRestrictmodalTrue = data.smioneLoginRestrictmodalTrue; 
    this.slides = data.slides; 
    this.isFromDashboard = data.isFromDashboard
    this.cardKey = data.cardKey
  }

  
  ngOnChanges() {
    this.updateCloseIcon();
  }
  
  updateCloseIcon() {
    if (this.smioneLoginRestrictmodalTrue) {
      this.closeIcon = "assets/images/cross-mark-close-login.png";
    } else if (this.showAlternateIntroPop) {
      this.closeIcon = "assets/images/close-green.png";
    } else {
      this.closeIcon = "assets/images/cross-mark-close.png";
    }
  }

  ngOnInit(): void {
    this.updateCloseIcon();
    this.startAutoSlide();
  }

  ngOnDestroy(): void {
    this.clearAutoSlide();
  }

  startAutoSlide(): void {
    this.clearAutoSlide();
    this.interval = setInterval(() => {
      this.nextSlide();
    }, 5000); 
  }

  clearAutoSlide(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  nextSlide(): void {
    this.currentSlideIndex = (this.currentSlideIndex + 1) % this.slides.length;
  }

  prevSlide(): void {
    this.currentSlideIndex = (this.currentSlideIndex - 1 + this.slides.length) % this.slides.length;
  }

  goToSlide(index: number): void {
    this.clearAutoSlide();
    this.currentSlideIndex = index;
    this.startAutoSlide();
  }
  
  getExternalSVAIDsFromCookies(): string[] {
    const cookieString = document.cookie
        .split('; ')
        .find(cookie => cookie.startsWith('ExternalSVAIDs='));

    try {
        return cookieString 
            ? JSON.parse(decodeURIComponent(cookieString.split('=')[1])) 
            : [];
    } catch (error) {
        console.error('Error parsing ExternalSVAIDs from cookies:', error);
        return [];
    }
}
 

 setCarouselShowToCookies(): void {
   
    const data = localStorage.getItem('data');
    if (!data) return;
    const parsedData = JSON.parse(data);
    const ExternalSVAIDValue = parsedData?.Cards?.[0]?.ExternalSVAID;
    sessionStorage.setItem('ExternalSVAIDForSession', ExternalSVAIDValue);
    if (!ExternalSVAIDValue) return;
    const existingSVAIDs = this.getExternalSVAIDsFromCookies();
    if (!existingSVAIDs.includes(ExternalSVAIDValue)) {
        existingSVAIDs.push(ExternalSVAIDValue);
        const expires = new Date();
        expires.setFullYear(expires.getFullYear() + 5);
        document.cookie = `ExternalSVAIDs=${encodeURIComponent(JSON.stringify(existingSVAIDs))}; path=/; expires=${expires.toUTCString()}; Secure; SameSite=Lax`;
    }
}

getDarkModalExternalSVAIDsFromCookies(): string[] {
    const cookieString = document.cookie
        .split('; ')
        .find(cookie => cookie.startsWith('DarkModalExternalSVAIDs='));

    try {
        return cookieString 
            ? JSON.parse(decodeURIComponent(cookieString.split('=')[1])) 
            : [];
    } catch (error) {
        console.error('Error parsing dark ExternalSVAIDs from cookies:', error);
        return [];
    }
}

setDarkCarouselShowToCookies(): void {
   
    const data = localStorage.getItem('data');
    if (!data) return;
    const parsedData = JSON.parse(data);
    const ExternalSVAIDValue = parsedData?.Cards?.[0]?.ExternalSVAID;
    sessionStorage.setItem('ExternalSVAIDForSessionDarkModal', ExternalSVAIDValue);
    if (!ExternalSVAIDValue) return;
    const existingSVAIDs = this.getDarkModalExternalSVAIDsFromCookies();
    if (!existingSVAIDs.includes(ExternalSVAIDValue)) {
        existingSVAIDs.push(ExternalSVAIDValue);
        const expires = new Date();
        expires.setFullYear(expires.getFullYear() + 5);
        document.cookie = `DarkModalExternalSVAIDs=${encodeURIComponent(JSON.stringify(existingSVAIDs))}; path=/; expires=${expires.toUTCString()}; Secure; SameSite=Lax`;
    }
}

  redirectToPlayStore(): void {
    // Redirect to Play Store for smi app
    window.open("https://play.google.com/store/apps/details?id=com.kudzumoneyllc.kudzu&pcampaignid=web_share", "_blank");
  }

  closeModal(): void {
    // this.setCarouselShowToCookies()
    // this.skipKudzuMigration();

    this.dialogRef.close();
    if (this.isFromDashboard == false) {
      const request = {
        cardKey: this.cardKey,
        screen: "KudzuMigrationCarousel",
        action: "Skip",
        migrationStatus:"MAYBE LATER"
      }
      this.dashboardServices.UpdateMigrationStatus(request).subscribe({
        next: (res) => {

        },
        error: () => {
        }
      })
    }else{

    }
     
  }

  DarkcloseModal(): void {
    // this.setDarkCarouselShowToCookies()
    // this.skipKudzuMigration();
    this.dialogRef.close();
    if (this.isFromDashboard == false) {
      const request = {
        cardKey: this.cardKey,
        screen: "KudzuMigrationPopup",
        action: "Skip",
        migrationStatus:"MAYBE LATER"
      }
      this.dashboardServices.UpdateMigrationStatus(request).subscribe({
        next: (res) => {

        },
        error: () => {
        }
      })
    }
  }

  closeModalMaybeLater(): void {
    // this.setCarouselShowToCookies()
    // this.skipKudzuMigration();
    this.dialogRef.close();

    if (this.isFromDashboard == false) {
      const request = {
        cardKey: this.cardKey,
        screen: "KudzuMigrationCarousel",
        action: "Skip",
        migrationStatus:"MAYBE LATER"
      }
      this.dashboardServices.UpdateMigrationStatus(request).subscribe({
        next: (res) => {

        },
        error: () => {
        }
      })
    }
  }

  closeDarkModalMaybeLater(): void {
    // this.setDarkCarouselShowToCookies()
    // this.skipKudzuMigration();
    if (this.isFromDashboard == false) {
      const request = {
        cardKey: this.cardKey,
        screen: "KudzuMigrationPopup",
        action: "Skip",
        migrationStatus:"MAYBE LATER"
      }
      this.dashboardServices.UpdateMigrationStatus(request).subscribe({
        next: (res) => {

        },
        error: () => {
        }
      })
    } else {

    }

    this.dialogRef.close();
  }

  letsgoButton(): void {
    // this.setCarouselShowToCookies()
    this.getKudzuUrl();
    if (this.isFromDashboard == false) {
      const request = {
        cardKey: this.cardKey,
        screen: "KudzuMigrationCarousel",
        action: "Initiated"
      }
      this.dashboardServices.UpdateMigrationStatus(request).subscribe({
        next: (res) => {

        },
        error: () => {
        }
      })
    } else {

    }

    this.dialogRef.close();
  }

  letsDarkModalGoButton(): void {
    // this.setDarkCarouselShowToCookies()
    this.getKudzuUrl();
    if (this.isFromDashboard == false) {
      const request = {
        cardKey: this.cardKey,
        screen: "KudzuMigrationPopup",
        action: "Initiated"
      }
      this.dashboardServices.UpdateMigrationStatus(request).subscribe({
        next: (res) => {

        },
        error: () => {
        }
      })
    }
    this.dialogRef.close();
  }
  

    getKudzuUrl()
    {
      this.dashboardServices.getKudzuUrl().subscribe(
        (res)=>{
          if (res?.RedirectUrl) {
            this.setCarouselShowToCookies()
            const updatedUrl = res.RedirectUrl
            window.open(updatedUrl, "_blank");
          }       
        }
      );
    }

    skipKudzuMigration()
    {
      this.dashboardServices.kudzuMigrationSkipCall().subscribe(
        (res)=>{
          //  alert(JSON.stringify(res))     
        }
      );
    }
  logitoKudzu(): void {
    window.open(this.appConfig.kudzu_login_Url,"_self");
  }
    

  logout(){
    sessionStorage.removeItem("token");
    if( this.oauthService.issuer)
      this.oauthService.logOut();
    let ADM_logout_url = this.restService.generateIDMLogoutUrl();
    if(localStorage.getItem("DeviceID")&& localStorage.getItem("DeviceID")!="")
    {
      const DeviceID = localStorage.getItem("DeviceID");
      const IsTrustedDevice = localStorage.getItem("IsTrustedDevice");
      localStorage.clear();
      localStorage.setItem("DeviceID", DeviceID);
      localStorage.setItem("IsTrustedDevice", IsTrustedDevice);
    }
    else
      localStorage.clear();
    sessionStorage.removeItem('alerts');
    window.open(ADM_logout_url, "_self");
  }


  handleKudzuLoginPopupClose(): void {
    this.logout()
    this.dialogRef.close();
    window.location.replace(window.location.origin);
  }
}
